import type { EmailTemplatesEventInvitation } from '@recruitee/email-templates-types';
import { createEntityCollectionStore, getEntityCollectionActions } from '@recruitee/ngrx';

import { EntityStoreKey } from '../types';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<EmailTemplatesEventInvitation>()(
    EntityStoreKey.EmailTemplatesEventInvitation,
    {
      idSelector: (entity: { id?: number | string | null }) => entity.id!,
      customActions: adapter => {
        const actions = getEntityCollectionActions(adapter, ({ id }) => id!);

        return {
          updatePositions: (state, payload: number[]) => adapter.markAsPending(state),
          updatePositionsSuccess: actions.fetchCollectionSuccess,
          updatePositionsFailed: actions.fetchCollectionFailed,
          duplicateTemplate: (state, payload: { id: number; correlationId: string }) =>
            actions.createOnePessimistic(state, {
              data: { id: payload.id },
              correlationId: payload.correlationId,
            }),
          duplicateTemplateSuccess: actions.createOnePessimisticSuccess,
          duplicateTemplateFailed: actions.createOnePessimisticFailed,
        };
      },
    },
  );

export {
  actions as EmailTemplatesEventInvitationActions,
  selectors as EmailTemplatesEventInvitationSelectors,
  reducer as EmailTemplatesEventInvitationReducer,
  namespace as EmailTemplatesEventInvitationNamespace,
};
